import React, { useEffect } from 'react';
import ScriptTag from 'react-script-tag';
import { useSelector } from 'react-redux';
import { YAHOO_TARGET } from '../../constants/yahoo';

const FLURRY_AD = {
  POPULAR_JOURNAL: process.env.REACT_APP_FLURRY_AD_POPULAR_JOURNAL,
  LATEST_JOURNAL: process.env.REACT_APP_FLURRY_AD_LATEST_JOURNAL,
  KEY: process.env.REACT_APP_FLURRY_KEY
};
const YahooFlurry = () => {
  const { target } = useSelector(state => state.init);
  useEffect(() => {
    if (YAHOO_TARGET === target) {
      window.native = window.native || [];
      window.native.push(FLURRY_AD.POPULAR_JOURNAL, FLURRY_AD.LATEST_JOURNAL);
      window.apiKey = FLURRY_AD.KEY;
    }
  }, [target]);

  return YAHOO_TARGET === target ? (
    <ScriptTag
      isHydrating
      async
      type="text/javascript"
      src="https://s.yimg.com/dy/ads/native.js"
    />
  ) : null;
};

export default YahooFlurry;
